import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {InvoiceStatus} from '../types/invoice';

@Pipe({
  name: 'originStatus',
  standalone: false,
})
export class OriginStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: InvoiceStatus): string {
    return (
      this.translate.instant(`enums.invoiceOrigin.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
